import { AppLayout } from "../shared";
import Organizations from "../Organizations/Organizations";

const Organizations_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <Organizations props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default Organizations_layout;
